import { breakpoints } from '@unistocks/shared/breakpoints';
import { applicationName } from 'expo-application';
import { isWeb } from 'tamagui';

export const APP_NAME = applicationName || 'Unistocks';

export const APP_HEADER = 'X-ApplicationName';
export const TENANT_HEADER = '__tenant';
export const ACCEPT_LANGUAGE_HEADER = 'Accept-Language';
export const CANCELLED_ERROR = 'CanceledError';

export const HOME_PAGE_URL = 'https://unistocks.se';

export const APP_BACKGROUND = require('@assets/bg-transparent.png');
export const LOGO_LIGHT = require('@assets/logo-light.png');
export const LOGO_DARK = require('@assets/logo-dark.png');
export const UNISTOCKS_ARROW = require('@assets/images/unistocks-arrow.png');
export const ASSET_DEFAULT_LIGHT = require('@assets/images/asset/default_light.webp');
export const ASSET_DEFAULT_DARK = require('@assets/images/asset/default_dark.webp');
export const CASH = require('@assets/images/asset/cash.svg');
export const SAVINGS_ACCOUNT = require('@assets/images/asset/savings-account.svg');

export const MAX_RESULT_COUNT = 10;
export const MAX_RESULT_COUNT_SEARCH = 20;

export const DEBOUNCE_TIME = 500;
export const RENDER_DELAY = 250;

export const SHEET_SNAP_POINTS = ['50%', '80%'];
export const SHEET_SIZE_SM = 450;
export const SHEET_SIZE_MD = breakpoints.sm;

export const OVERLAY_OPACITY = 0.55;
export const PRESSABLE_OPACITY = 0.6;
export const PRESSABLE_SCALE = 0.95;
export const DISABLED_OPACITY = 0.75;
export const SUBTITLE_OPACITY = 0.6; // Same as Tamagui ListItem.Subtitle

export const STORAGE_ID = 'unistocks';
export const QUERY_STORAGE_VERSION = '3';
export const REDUX_STORAGE_VERSION = 3;

/* Font Family */
const FONT_FAMILY = 'Poppins';
export const FONT_FAMILY_REGULAR = isWeb ? FONT_FAMILY : 'Poppins_400Regular';
export const FONT_FAMILY_MEDIUM = isWeb ? FONT_FAMILY : 'Poppins_500Medium';
export const FONT_FAMILY_SEMI_BOLD = isWeb ? FONT_FAMILY : 'Poppins_600SemiBold';
export const FONT_FAMILY_BOLD = isWeb ? FONT_FAMILY : 'Poppins_700Bold';
export const FONT_FAMILY_EXTRA_BOLD = isWeb ? FONT_FAMILY : 'Poppins_800ExtraBold';
export const FONT_FAMILY_BLACK = isWeb ? FONT_FAMILY : 'Poppins_900Black';
